import { Text, Stack } from 'braid-design-system';
import type { ComponentProps } from 'react';

import { parseAndSplitHtmlText } from 'src/utils/parseAndSplitHtmlText';

import HotjarMask from '../../components/common/HotjarMask';
import SimpleFormat from '../../components/common/SimpleFormat';

type StackProps = ComponentProps<typeof Stack>;

interface Props {
  content: string;
  isSecondary?: boolean;
  size?: 'standard' | 'small' | 'xsmall' | 'large';
  space?: StackProps['space'];
}

export const HtmlContent: React.FC<Props> = ({
  content,
  isSecondary = true,
  size = 'standard',
  space = 'small',
}) => (
  <Stack space={space}>
    {parseAndSplitHtmlText(content).map((lines, index) => (
      <Text
        key={index}
        tone={isSecondary ? 'secondary' : 'neutral'}
        size={size}
      >
        <HotjarMask>
          <SimpleFormat text={lines} />
        </HotjarMask>
      </Text>
    ))}
  </Stack>
);
